/* Form Page to add and edit the Scene Breakdown section
 * The Script and Storyboard can be added or edited here as well
 * Scene numbers cannot be edited un;ess the unfreeze button is clicked */
import React, { useEffect, useRef, useState } from "react";

import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import { Alert, Image } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import Asset from "../../../components/Asset";
import Upload from "../../../assets/upload.png";
import { axiosInstance, axiosReq } from "../../../api/axiosDefaults";
import TopBox from "../../../components/TopBox";
import { useRedirect } from "../../../hooks/Redirect";
import NewLocation from "./NewLocation";
import {
  useLocationsContext,
  useSetLocationsContext,
} from "../../../contexts/Scene_chars_locs";
import Important from "../info/Important";
import Info from "../info/Info";
import { useCrewInfoContext } from "../../../contexts/BaseCallContext";
import { CLIENT_PROGRAM_HOSTNAME } from "../../../utils/config";
import useHostName from "../../../hooks/useHostName";
import { useCurrentUser } from "../../../contexts/CurrentUserContext";
import toast from "react-hot-toast";
import styles from "../../../styles/Scene.module.css";
import appStyles from "../../../App.module.css";
import btnStyles from "../../../styles/Button.module.css";

const MAX_FILE_SIZE_MB = 5;
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

const BreakdownEditForm = () => {
  const host = useHostName();
  const currentUser = useCurrentUser();
  const projectType = currentUser?.project_category_type
    ? JSON.parse(currentUser?.project_category_type)
    : null;
  useRedirect();
  const crewInfoOne = useCrewInfoContext();
  const freeze = crewInfoOne?.freeze || "";
  const [errors, setErrors] = useState({});
  const [showAddLoc, setShowAddLoc] = useState(false);
  const locations = useLocationsContext();
  const setLocations = useSetLocationsContext();
  const [showImp, setShowImp] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  // eslint-disable-next-line
  const [sceneNumber, setSceneNumber] = useState("");

  const queryString = window.location.search;

  // Use URLSearchParams to parse the query string
  const params = new URLSearchParams(queryString);
  // Retrieve the "episode" parameter
  const episode = params.get("episode");
  const project = params.get("project");
  const episodeTitle = params.get("episodeTitle");

  const [postData, setPostData] = useState({
    number: "",
    title: "",
    act: "",
    int_ext: "",
    day_night: "",
    time: "",
    pages: "",
    location: "",
    location_detail: "",
    filming_location: "",
    shooting_date: "",
    action: "",
    department_info: "",
    equip_set_props: "",
    dramatic_day: "",
    storyboard: "",
    storyboardType: null,
    script: "",
    scriptType: null,
    is_frozen: false,
  });

  const {
    number,
    title,
    act,
    int_ext,
    day_night,
    location,
    filming_location,
    dramatic_day,
    equip_set_props,
    department_info,
    pages,
    action,
    storyboard,
    script,
    is_frozen,
    shooting_date,
    time,
    location_detail,
  } = postData;

  const imageInput = useRef(null);
  const storyboardInput = useRef(null);

  const validateFileSize = (file, inputRef) => {
    if (file.size <= MAX_FILE_SIZE_BYTES) {
      return true;
    }

    if (inputRef?.current) {
      inputRef.current.value = "";
    }

    toast.error(`Only ${MAX_FILE_SIZE_MB} MB files are allowed.`);
    return false;
  };

  const history = useHistory();
  const { id } = useParams();

  useEffect(() => {
    const handleMount = async () => {
      try {
        const fetchContentType = async (url) => {
          const response = await fetch(url, { method: "HEAD" });
          return response.headers.get("Content-Type");
        };
        if (host === CLIENT_PROGRAM_HOSTNAME) {
          const { data } = await axiosReq.get(`/scenes/${id}/`);
          const {
            number,
            title,
            act,
            int_ext,
            day_night,
            time,
            location,
            filming_location,
            shooting_date,
            dramatic_day,
            equip_set_props,
            department_info,
            pages,
            action,
            storyboard,
            script,
            location_detail,
          } = data;
          const [type1, type2] = await Promise.all([
            script ? fetchContentType(script) : null,
            storyboard ? fetchContentType(storyboard) : null,

          ]);
          setPostData({
            number,
            title,
            act,
            int_ext,
            day_night,
            time,
            location,
            filming_location,
            shooting_date,
            dramatic_day,
            equip_set_props,
            department_info,
            pages,
            action,
            storyboard,
            script,
            location_detail,
            scriptType: type1,
            storyboardType: type2

          });
          setSceneNumber(number);
        } else {
          const { data } = await axiosInstance.get(
            `${localStorage.getItem("projectSlug")}/scenes/${id}/`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
              },
              withCredentials: true,
            }
          );
          const {
            number,
            title,
            act,
            int_ext,
            day_night,
            time,
            location,
            filming_location,
            shooting_date,
            dramatic_day,
            equip_set_props,
            department_info,
            pages,
            action,
            storyboard,
            script,
            location_detail,
            is_frozen,
          } = data;


          const [type1, type2] = await Promise.all([
            script ? fetchContentType(script) : null,
            storyboard ? fetchContentType(storyboard) : null,
          ]);

          console.log(is_frozen)

          setPostData({
            number,
            title,
            act,
            int_ext,
            day_night,
            time,
            location,
            filming_location,
            shooting_date,
            dramatic_day,
            equip_set_props,
            department_info,
            pages,
            action,
            storyboard,
            script,
            location_detail,
            is_frozen,
            scriptType: type1,
            storyboardType: type2
          });
          setSceneNumber(number);
        }
      } catch (err) {
        console.log(err);
      }
    };

    handleMount();
  }, [id]);

  const handleChange = (event) => {
    setPostData({
      ...postData,
      [event.target.name]: event.target.value,
    });
  };

  const handleChangeImage = (event) => {
    if (!event.target.files.length) {
      return;
    }
    const file = event.target.files[0];
    if (!validateFileSize(file, imageInput)) {
      return;
    }
    URL.revokeObjectURL(script);
    setPostData({
      ...postData,
      script: URL.createObjectURL(file),
      scriptType: file.type,
    });
  };

  const handleChangeStoryboard = (event) => {
    if (!event.target.files.length) {
      return;
    }
    const file = event.target.files[0];
    if (!validateFileSize(file, storyboardInput)) {
      return;
    }
    URL.revokeObjectURL(storyboard);
    setPostData({
      ...postData,
      storyboard: URL.createObjectURL(file),
      storyboardType: file.type,
    });
  };

  {/* old version not now being used */}
      // <Row>
      //   {/* Freeze - This may be removed */}
      //   {freeze ? (
      //     <Col className=" p-0 p-md-2" xs={4}>
      //       <p>Number</p>
      //       <p>{number}</p>
      //     </Col>
      //   ) : (
      //     <Col className="d-flex justify-content-center p-0 p-md-2" xs={4}>
      //       <Form.Group controlId="number" className={`${styles.Width2} `}>
      //         <Form.Label className={`${styles.Bold}`}>Number</Form.Label>
      //         <Form.Control
      //           className={styles.Input}
      //           type="text"
      //           name="number"
      //           value={number}
      //           onChange={handleChange}
      //           disabled={postData.is_frozen}
      //         />
      //       </Form.Group>
      //       {errors?.number?.map((message, idx) => (
      //         <Alert variant="warning" key={idx}>
      //           {message}
      //         </Alert>
      //       ))}
      //     </Col>
      //   )}
      //   <Col className="d-flex justify-content-center p-0 p-md-2" xs={4}>
      //     <Form.Group controlId="title" className={`${styles.Width2} `}>
      //       <Form.Label className={`${styles.Bold}`}>Title</Form.Label>
      //       <Form.Control
      //         // placeholder="Title"
      //         className={styles.Input}
      //         type="text"
      //         name="title"
      //         value={title}
      //         onChange={handleChange}
      //       />
      //     </Form.Group>
      //     {errors?.title?.map((message, idx) => (
      //       <Alert variant="warning" key={idx}>
      //         {message}
      //       </Alert>
      //     ))}
      //   </Col>
      //   <Col className="d-flex justify-content-center p-0 p-md-2" xs={4}>
      //     <Form.Group controlId="dramatic_day" className={`${styles.Width2} `}>
      //       <Form.Label className={`${styles.Bold}`}>Dramatic Day</Form.Label>
      //       <Form.Control
      //         type="text"
      //         className={styles.Input}
      //         // placeholder="Dramatic Day"
      //         name="dramatic_day"
      //         value={dramatic_day}
      //         onChange={handleChange}
      //       />
      //     </Form.Group>
      //     {errors?.dramatic_day?.map((message, idx) => (
      //       <Alert variant="warning" key={idx}>
      //         {message}
      //       </Alert>
      //     ))}
      //   </Col>
      // </Row>

  const infoFields = (
    <div className="mt-0 text-center px-2">
      {projectType !== "Television" ? (
      <Row className="mt-1">
        {/* UnFreeze - is_frozen = false at start and means they are frozen.
        using is_frozen backwards so as to start with Frozen Scenes  */}
        {is_frozen ? (
          <Col className="d-flex justify-content-center p-0 p-md-2" xs={6} >
          <Form.Group controlId="number" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Number</Form.Label>
              <Form.Control 
              className={styles.Input}
              type="text"
              name="number"
              value={number}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.number?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
        ) : (
          <Col className=" p-0 p-md-2" xs={6}>
          <p className={`${styles.BoldScene}`}>Number</p>
          <p>{number}</p>
          </Col>
        ) }         
          <Col className="d-flex justify-content-center p-0 p-md-2" xs={6}>
          <Form.Group controlId="act" className={`${styles.Width2} `} >
              <Form.Label className={`${styles.BoldScene}`} >Act</Form.Label>
              <Form.Control as="select"
                className={styles.InputEx}
                name="act"
                value={act}
                onChange={handleChange}
                aria-label="act select">
                <option></option>
                <option value="one">One</option>
                <option value="two-a">Two - First Half</option>
                <option value="two-b">Two - Second Half</option>
                <option value="three">Three</option>
              </Form.Control>
              </Form.Group>
              {errors?.act?.map((message, idx) => (
                <Alert variant="warning" key={idx}>
                  {message}
                </Alert>
              ))}
          </Col>
      </Row>
      ) : (
      <Row className="mt-1">
        {/* Freeze  */}
        {is_frozen ? (
          <Col className="d-flex justify-content-center p-0 p-md-2" xs={{ span: 6, offset: 3 }} >
          <Form.Group controlId="number" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Number</Form.Label>
              <Form.Control 
              className={styles.Input}
              type="text"
              name="number"
              value={number}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.number?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
        ) : (
          <Col className=" p-0 p-md-2" xs={{ span: 6, offset: 3 }}>
          <p className={`${styles.BoldScene}`}>Number</p>
          <p>{number}</p>
          </Col>
        ) } 
      </Row>
      )}
      {/* hr */}
      <Row>
      <Col md={{span: 8, offset: 2}} >
       <hr className={`mt-3 mb-3`}/> 
      </Col>
      </Row>
      <Row>
      <Col md={{span: 6, offset: 3}} >
      <span className={`py-0 mb-3 px-5 mt-3 ${styles.SubTitleBlack }`} >
        SCRIPT INFO</span>  
      </Col>
      </Row>
      {/* Int-Ext loc Day/Night */}
      <Row className="mt-3">
      <Col className="d-flex justify-content-center p-0 p-md-2" xs={{ span: 6, order: 1 }} md={{ span: 3, order: 1 }} >         
          <Form.Group controlId="int_ext" className={`${styles.Width2} `} >
              <Form.Label className={`${styles.BoldScene}`} >Int-Ext</Form.Label>
              <Form.Control as="select"
                className={styles.InputEx}
                name="int_ext"
                value={int_ext}
                onChange={handleChange}
                aria-label="int ext select">
                <option></option>
                <option value="int.">Int</option>
                <option value="ext.">Ext</option>
              </Form.Control>
          </Form.Group>
          {errors?.int_ext?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
      </Col>
      <Col className="d-flex justify-content-center mt-3 mt-md-0 p-0 p-md-2" xs={{ span: 12, order: 12 }} md={{ span: 6, order: 2}} >
          <Form.Group controlId="location" className={`${styles.Width2} `} >
              <Form.Label className={`${styles.BoldScene}`} >Location</Form.Label>
              <Form.Control as="select"
                name="location"
                className={styles.Input}
                value={location}
                onChange={handleChange}
                aria-label="location select">
                  <option  ></option>
                {locations.results.length && (
                    locations.results.map((location) => (
                      <option key={location.id} value={location.name} >{location.name}</option>
                    ) )) }
              </Form.Control>
          </Form.Group>
          {errors?.location?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
      </Col>
      <Col className="d-flex justify-content-center p-0 p-md-2" xs={{ span: 6, order: 2 }} md={{ span: 3, order: 12 }}  >
      <Form.Group controlId="day_night" className={`${styles.Width2} `} >
          <Form.Label className={`${styles.BoldScene}`} >Day/Night</Form.Label>
          <Form.Control as="select"
            name="day_night"
            className={styles.InputEx}
            value={day_night}
            onChange={handleChange}
            aria-label="day or night select">
            <option></option>
            <option value="DAY">Day</option>
            <option value="NIGHT">Night</option>
          </Form.Control>
      </Form.Group>
      {errors?.day_night?.map((message, idx) => (
        <Alert variant="warning" key={idx}>
          {message}
        </Alert>
      ))}
      </Col>
      </Row  >
      {/* hr */}
      <hr className={`mt-3 mb-0`}/>
      {/* heading - Action */}
      <Row className="mt-3">
        <Col className="d-flex justify-content-center p-0 p-md-2" xs={12} md={6}>
          <Form.Group controlId="title" className={`${styles.Width2} `} >
              <Form.Label className={`${styles.BoldScene}`}>Heading Info</Form.Label>
              <Form.Control 
              className={styles.Input}
              type="text"
              name="title"
              value={title}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.title?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
        <Col className="d-flex justify-content-center mt-3 mt-md-0 p-0 p-md-2" xs={12} md={6}>
        <Form.Group controlId="action" className={`${styles.Width2} `} >
            <Form.Label className={`${styles.BoldScene}`} >Action</Form.Label>
            <Form.Control 
            type="text"
            className={styles.InputScene}
            as="textarea"
            rows={2}
            name="action"
            value={action}
            onChange={handleChange}
                />
        </Form.Group>
        {errors?.action?.map((message, idx) => (
          <Alert variant="warning" key={idx}>
            {message}
          </Alert>
        ))}
        </Col>
      </Row>
      {/* hr */}
      <hr className={`mt-3 mb-0`}/>
      {/* pages - d day */}
      <Row className="mt-3">
      <Col className="d-flex justify-content-center p-0 p-md-2" xs={6}>
      <Form.Group controlId="pages" className={`${styles.Width2} `} >
          <Form.Label className={`${styles.BoldScene}`} >Pages</Form.Label>
          <Form.Control 
          type="text"
          className={styles.Input}
          placeholder="Decimal only"
          name="pages"
          value={pages}
          onChange={handleChange}
              />
      </Form.Group>
      {errors?.pages?.map((message, idx) => (
        <Alert variant="warning" key={idx}>
          {message}
        </Alert>
      ))}
      </Col>
      <Col className="d-flex justify-content-center mt-1 mt-md-0 p-0 p-md-2" xs={6} >
          <Form.Group controlId="dramatic_day" className={`${styles.Width2} `} >
              <Form.Label className={`${styles.BoldScene} d-block d-md-none `} >D. Day</Form.Label>
              <Form.Label className={`${styles.BoldScene} d-none d-md-block `} >Dramatic Day</Form.Label>
              <Form.Control 
              type="text"
              className={styles.Input}
              name="dramatic_day"
              value={dramatic_day}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.dramatic_day?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
      </Col>
      </Row >
      {/* hr */}
      <hr className={`mt-3 mb-0`}/>
      <Row className="mt-5">
      <Col md={{span: 6, offset: 3}} >
      <span className={`py-0 mb-3 px-5 ${styles.SubTitleBlack }`} >
        SHOOT & POST INFO</span>  
      </Col>
      </Row>
      {/* equip - vfx  */}
      <Row className="mt-3">
      {/* filming location name - VFX using location_detail */}
      {/* <Col className="d-flex justify-content-center p-0 p-md-2" xs={6}>
        <Form.Group controlId="filming_location" className={`${styles.Width2} `} >
            <Form.Label className={`${styles.BoldScene}`} >Shoot Location Name</Form.Label>
            <Form.Control 
            type="text"
            className={styles.Input}
            name="filming_location"
            value={filming_location}
            onChange={handleChange}
                />
        </Form.Group>
        {errors?.filming_location?.map((message, idx) => (
          <Alert variant="warning" key={idx}>
            {message}
          </Alert>
        ))}
      </Col> */}
      <Col className="d-flex justify-content-center p-0 p-md-2" xs={12} md={6}>
      <Form.Group controlId="equip_set_props" className={`${styles.Width2} `} >
          <Form.Label className={`${styles.BoldScene}`} >Equipment/Set/Props</Form.Label>
          <Form.Control 
              className={styles.InputScene}
              type="text"
              name="equip_set_props"
              as="textarea"
              rows={2}
              value={equip_set_props}
              onChange={handleChange}
              />
      </Form.Group>
      {errors?.equip_set_props?.map((message, idx) => (
        <Alert variant="warning" key={idx}>
          {message}
        </Alert>
      ))}
      </Col>
      <Col className="d-flex justify-content-center mt-3 mt-md-0 p-0 p-md-2" xs={12} md={6}>
        <Form.Group controlId="location_detail" className={`${styles.Width2} `} >
            <Form.Label className={`${styles.BoldScene}`} >Stunts / SFX / VFX</Form.Label>
            <Form.Control 
            type="text"
            className={styles.InputScene}
            name="location_detail"
            as="textarea"
            rows={2}
            value={location_detail}
            onChange={handleChange}
                />
        </Form.Group>
        {errors?.location_detail?.map((message, idx) => (
          <Alert variant="warning" key={idx}>
            {message}
          </Alert>
        ))}
        </Col>
      </Row>
      {/* hr */}
      <hr className={`mt-3 mb-0`}/>
      {/* story /editing info using "time" - music using shooting_date */}
      <Row className="mt-3">
        <Col className="d-flex justify-content-center p-0 p-md-2" xs={12} md={6}>
          <Form.Group controlId="time" className={`${styles.Width2} `} >
              <Form.Label className={`${styles.BoldScene}`}>Story / Editing</Form.Label>
              <Form.Control 
              className={styles.InputScene}
              type="text"
              as="textarea"
              rows={2}
              name="time"
              value={time}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.time?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
        </Col>
        <Col className="d-flex justify-content-center p-0 p-md-2" xs={6}>
      <Form.Group controlId="shooting_date" className={`${styles.Width2} `} >
          <Form.Label className={`${styles.BoldScene}`} >Post Sound / Music</Form.Label>
          <Form.Control 
          type="text"
          className={styles.InputScene}
          as="textarea"
          rows={2}
          name="shooting_date"
          value={shooting_date}
          onChange={handleChange}
              />
      </Form.Group>
      {errors?.shooting_date?.map((message, idx) => (
        <Alert variant="warning" key={idx}>
          {message}
        </Alert>
      ))}
      </Col>
      </Row>
      {/* hr */}
      <hr className={`mt-3 mb-0`}/>
      {/* department shooting info - equip_set_props  */}
      <Row className="mt-3">
      <Col className="d-flex justify-content-center p-0 p-md-2" 
      xs={12} md={{span: 8, offset: 2}}>
        <Form.Group controlId="content" className={`${styles.Width2} `} >
            <Form.Label className={`${styles.BoldScene}`} >Departments/Shoot Info</Form.Label>
            <Form.Control 
                type="text"
                className={styles.InputScene}
                name="department_info"
                as="textarea"
                rows={2}
                value={department_info}
                onChange={handleChange}
                />
        </Form.Group>
        {errors?.department_info?.map((message, idx) => (
          <Alert variant="warning" key={idx}>
            {message}
          </Alert>
        ))}
      </Col>
      </Row>    
      {/* hr */}
      <hr className={`mt-3 mb-0`}/>
    </div>
  )

  const buttons = (
    <div className={`text-center pt-3 mt-3 mb-3 pb-2 ${styles.White}`}>
      <Button
        className={`mr-3 px-3 px-md-5 ${btnStyles.Button} ${btnStyles.Blue}`}
        onClick={() => history.goBack()}
      >
        Cancel
      </Button>
      <Button
        className={`ml-3 px-3 px-md-5  ${btnStyles.Button} ${btnStyles.Blue}`}
        type="submit"
      >
        Submit
      </Button>
    </div>
  );

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!int_ext || !day_night) {
      toast.error("Int-Ext and Day/Night are required fields.");
      return;
    }
    const formData = new FormData();

    formData.append("number", number);
    formData.append("title", title);
    if (projectType !== "Television") {
      formData.append("act", act);
    }
    formData.append("int_ext", int_ext);
    formData.append("day_night", day_night);
    formData.append("time", time);
    formData.append("pages", pages);
    formData.append("dramatic_day", dramatic_day);
    formData.append("location", location);
    formData.append("location_detail", location_detail);
    formData.append("filming_location", filming_location);
    formData.append("shooting_date", shooting_date);
    formData.append("action", action);
    formData.append("equip_set_props", equip_set_props);
    formData.append("department_info", department_info);
    if (imageInput.current.files[0]) {
      formData.append("script", imageInput.current.files[0]);
    }
    if (storyboardInput.current.files[0]) {
      formData.append("storyboard", storyboardInput.current.files[0]);
    }

    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        const data = await axiosReq.put(`/scenes/${id}/`, formData);
        if (data?.success === false) {
          toast.error(data?.error?.response?.data.non_field_errors[0], {
            duration: 3000,
            position: "top-right",
          });
        } else {
          history.push(`/${localStorage.getItem("projectSlug")}/scenes/${id}/`);
          toast.success(`Scene Updated`);
        }
      } else {
        const data = await axiosInstance.put(
          `${localStorage.getItem("projectSlug")}/scenes/${id}/`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        );

        if (data?.success === false) {
          toast.error(data?.error?.response?.data.non_field_errors[0], {
            duration: 3000,
            position: "top-right",
          });
        }
        else {
          history.push(
            `/${localStorage.getItem("projectSlug")}/scenes/${id}${episode && project && episodeTitle
              ? `?episode=${episode}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
            }`
          );
          toast.success(`Scene Updated Successfully!`);
        }
      }
    } catch (err) {
      if (err.response?.status !== 401) {
        setErrors(err.response?.data);
      }
    }
  };

  return (
    <div>
      <TopBox
        scene={`${number} `}
        title3="Add / Update Breakdown"
        episodeTitle={`Episode ${episodeTitle}`}
      />
      <Row>
        <Col xs={6}>
          <Button
            className={`${btnStyles.Button} ${btnStyles.Blue} py-0 mt-2`}
            onClick={() => history.goBack()}
          >
            Back
          </Button>
        </Col>
        <Col xs={6}>
          <Button
            className={`float-right py-0 mt-2 ${btnStyles.Order} ${btnStyles.Button}`}
            onClick={() => setShowInfo((showInfo) => !showInfo)}
          >
            Pages Info
          </Button>
        </Col>
      </Row>
      <Row>
        <Col>{!showInfo ? "" : <Important />}</Col>
      </Row>
      <Row className="mt-3">
        <Col className="text-center px-0" xs={6}>
          <Button
            className={`${btnStyles.Button} px-2 px-md-3 ${btnStyles.Order} `}
            onClick={() => setShowAddLoc((showAddLoc) => !showAddLoc)}
          >
            ADD NEW LOCATION
          </Button>
        </Col>
        <Col className="text-center px-0" xs={5}>
          <Button
            className={`px-4 px-md-5 ${btnStyles.Order} ${btnStyles.Button}`}
            onClick={() => setShowImp((showImp) => !showImp)}
          >
            IMPORTANT
          </Button>
        </Col>
      </Row>
      {!showImp ? "" : <Info />}
      {!showAddLoc ? (
        ""
      ) : (
        <NewLocation
          setShowAddLoc={setShowAddLoc}
          setLocations={setLocations}
        />
      )}
      <h5 style={{ textTransform: 'uppercase'}}
         className={`text-center mt-3 mb-0 py-1 ${styles.SubTitle }`}>
        ADD / UPDATE SCENE {number}  BREAKDOWN
      </h5>
      <Form className={`mb-3 px-3 ${styles.Back}`} onSubmit={handleSubmit}>
        <Row>
          <Col xs={12} className="p-0 p-md-2">
            {infoFields}
          </Col>
        </Row>
        <Row className="mt-5 text-center">
      <Col md={{span: 6, offset: 3}} >
      <span className={`py-0 mb-3 px-5 ${styles.SubTitleBlack }`} >
        SCRIPT & STORYBOARD</span>  
      </Col>
      </Row>
        <Row>
          <Col className="py-2 p-0 p-md-2" md={6}>
            <p className={`${styles.Bold} text-center mb-1`}>Script</p>
            <Container
              className={`${appStyles.Content} ${styles.Width2}  ${styles.Container} d-flex flex-column justify-content-center mb-3`}
            >
              <Form.Group className="text-center pt-3">
                {script ? (
                  postData?.scriptType === "application/pdf" ? (
                    <>
                      <iframe
                        src={script}
                        width="40%"
                        height="100px"
                        style={{ borderRadius: 8, border: "none" }}
                        title="PDF Preview"
                      />
                      <Form.Label
                        className={`${btnStyles.Button} ${btnStyles.GreyDark}`}
                        htmlFor="image-upload1"
                      >
                        Change the Script
                      </Form.Label>
                    </>
                  ) : (
                    <>
                      <figure>
                        <Image
                          className={appStyles.iframe}
                              width="70%"
                              height="120px"
                          src={script}
                          rounded
                        />
                      </figure>
                      <Form.Label
                        className={`${btnStyles.Button} ${btnStyles.GreyDark}`}
                        htmlFor="image-upload1"
                      >
                        Change the Script
                      </Form.Label>
                    </>
                  )
                ) : (
                  <Form.Label
                    className="d-flex justify-content-center"
                    htmlFor="image-upload1"
                  >
                    <Asset src={Upload} message="Upload Script" />
                  </Form.Label>
                )}
                <Form.Control
                  type="file"
                  id="image-upload1"
                  accept="image/*,application/pdf"
                  onChange={handleChangeImage}
                  ref={imageInput}
                />
              </Form.Group>
              {errors?.script?.map((message, idx) => (
                <Alert variant="warning" key={idx}>
                  {message}
                </Alert>
              ))}
            </Container>
          </Col>
          <Col className="py-2 p-0 p-md-2" md={6}>
            <p className={`${styles.Bold} text-center mb-1`}>Storyboard</p>
            {/* storyboard */}
            <Container
              className={`${appStyles.Content} ${styles.Width2} ${styles.Container} d-flex flex-column justify-content-center`}
            >
              <Form.Group className="text-center pt-3">
                {storyboard ? (
                  postData?.storyboardType === "application/pdf" ? (
                    <>
                      <iframe
                        src={storyboard}
                          width="40%"
                          height="100px"
                        style={{ borderRadius: 8, border: "none" }}
                        title="PDF Preview"
                      />
                      <Form.Label
                        className={`${btnStyles.Button} ${btnStyles.GreyDark}`}
                        htmlFor="image-upload2"
                      >
                        Change the Storyboard
                      </Form.Label>
                    </>
                  ) : (
                    <>
                      <figure>
                        <Image
                          className={appStyles.iframe}
                            width="70%"
                            height="100px"
                          src={storyboard}
                          rounded
                        />
                      </figure>
                      <Form.Label
                        className={`${btnStyles.Button} ${btnStyles.GreyDark}`}
                        htmlFor="image-upload2"
                      >
                        Change the Storyboard
                      </Form.Label>
                    </>
                  )
                ) : (
                  <Form.Label
                    className="d-flex justify-content-center"
                    htmlFor="image-upload2"
                  >
                    <Asset src={Upload} message="Upload Storyboard" />
                  </Form.Label>
                )}
                <Form.Control
                  type="file"
                  id="image-upload2"
                  accept="image/*,application/pdf"
                  onChange={handleChangeStoryboard}
                  ref={storyboardInput}
                />
              </Form.Group>

              {errors?.storyboard?.map((message, idx) => (
                <Alert variant="warning" key={idx}>
                  {message}
                </Alert>
              ))}
            </Container>
          </Col>
        </Row>
        <Row>
          <Col className="text-center">
            <div className={`mt-3 ${styles.Container}`}>{buttons}</div>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default BreakdownEditForm;
